<!-- Profile Header Component -->
<ms-user-profile-header [(user)]="user" [isLoading]="isLoading()" [platformRole]="platformRole()" [navItems]="filteredNavItems()" (tabChanged)="onTabChanged($event)" (userUpdated)="onUserUpdated()" (editProfileRequested)="onEditProfileRequested()"></ms-user-profile-header>

<!-- Tab Content Cards -->
<div class="tab-content mx-0 mx-sm-4 border-0" id="profileTabsContent">
  @if (user()) {
  @for (item of filteredNavItems(); track item.id; let i = $index) {
    @if (item.active) {
      <div class="tab-pane fade" [class.show]="item.active" [class.active]="item.active" [id]="item.id" role="tabpanel"
        [attr.aria-labelledby]="item.id + '-tab'" tabindex="0">

        <!-- Content slot for each tab -->
        @switch (item.id) {

        <!-- Overview Content -->
        @case ('overview') {
          <ms-user-overview [(user)]="user" [organizationMemberships]="organizationMemberships"></ms-user-overview>
        }

        <!-- Settings Content -->
        @case ('settings') {
          <ms-user-settings [user]="user()"></ms-user-settings>
        }

        <!-- Security Content -->
        @case ('security') {
          <ms-user-security [user]="user()"></ms-user-security>
        }

        @case ('logs') {
          <ms-user-logs [user]="user()"></ms-user-logs>
        }

        <!-- Default Content for other tabs -->
        @default {
        <div class="card">
          <div class="card-body">
            <p>Content for {{item.label}} will be implemented here.</p>
          </div>
        </div>
        }
        }
      </div>
    }
  }
  }
</div>
